import {Inject, Injectable} from "@angular/core";
import {AgendaelementId, AgendaelementModell, ArkivnodeId, BeslutningId, DokumentId, DokumentVersjonId, EntitetReferanseModell, Epost, GruppeId, MedlemId, MøteId, OppgaveId, OppgaveModell, OppgavePagineringSpesifikasjon, OppgaveSorteringSpesifikasjon, OppgavestatusKriterie} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {plainDateSomDate} from "felles-ng2/støttefunksjoner/temporalTilDateKonverteringer";
import {tilUtcDatoIgnorerTs} from "felles/tjenester/Datoer";
import {PlainDatePeriode} from "felles-ng2/støttefunksjoner/plainDatePerioder";
import {ajs_$rootScope_DI_TOKEN, AjsRootScopeService} from "web-ng2/tjenester/ajs/AjsRootScopeService";
import {ajs_WebNavigasjon_DI_TOKEN, AjsWebNavigasjon} from "web-ng2/tjenester/ajs/AjsWebNavigasjon";
import {AgendaelementModellDLM} from "felles-ng2/tjenester/datalager/SakDatatjeneste";

/** Tjeneste for navigering i applikasjonen.
 * Inntil videre delegeres navigering videre til webNavigasjon fra ajs */
@Injectable({providedIn: 'root'})
export class Navigasjon {

    constructor(@Inject(ajs_WebNavigasjon_DI_TOKEN) private ajsNavigasjon: AjsWebNavigasjon, @Inject(ajs_$rootScope_DI_TOKEN) private ajsRootScope: AjsRootScopeService) {
    }

    gåTilForsiden() {
        this.ajsNavigasjon.gåTilForsiden();
    }

    gåTilAdministrasjonSøk() {
        this.ajsNavigasjon.gåTilAdministrasjonSøk();
    }

    gåTilAdministrasjonAvtaler() {
        this.ajsNavigasjon.gåTilAdministrasjonAvtaler();
    }

    gåTilAdministrasjonBrukere() {
        this.ajsNavigasjon.gåTilAdministrasjonBrukere();
    }

    gåTilAdministrasjonMeldinger() {
        this.ajsNavigasjon.gåTilAdministrasjonMeldinger();
    }

    gåTilAdministrasjonAsynkOppgaver() {
        this.ajsNavigasjon.gåTilAdministrasjonAsynkOppgaver();
    }

    gåTilAdministrasjonSpørreskjemaer() {
        this.ajsNavigasjon.gåTilAdministrasjonSpørreskjemaer();
    }

    gåTilGruppe(id: GruppeId) {
        this.ajsNavigasjon.gåTilGruppe(id);
    }

    gåTilGrupper() {
        this.ajsNavigasjon.gåTilGrupper();
    }

    gåTilGruppeAsync(id: GruppeId) {
        this.ajsRootScope.$evalAsync(() => {
            this.ajsNavigasjon.gåTilGruppe(id);
        });
    }

    gåTilMedlem(gruppeId: GruppeId, medlemId: MedlemId) {
        this.ajsNavigasjon.gåTilMedlem(gruppeId, medlemId);
    }

    gåTilOpprettPlanMedPeriodeValgt(gruppeId: GruppeId, periode: PlainDatePeriode) {
        //gåTilOpprettPlanMedPeriodeValgt forventer en periode angitt i UTC med start 1.jan 00:00 (UTC) og slutt 31.des 23:59 (UTC)
        const utcPeriode = {
            start: tilUtcDatoIgnorerTs(plainDateSomDate(periode.start)!),
            slutt: tilUtcDatoIgnorerTs(plainDateSomDate(periode.slutt)!)
        }
        this.ajsNavigasjon.gåTilOpprettPlanMedPeriodeValgt(gruppeId, utcPeriode);
    }

    gåTilSignerSaksdokument(dokumentId: DokumentId) {
        this.ajsNavigasjon.gåTilSignerSaksdokument(dokumentId);
    }

    gåTilSignerArkivdokument(dokumentId: DokumentId) {
        this.ajsNavigasjon.gåTilSignerArkivdokument(dokumentId);
    }

    gåTilSakKnyttetTilDokumentVersjon(dokumentVersjonId: DokumentVersjonId) {
        this.ajsNavigasjon.gåTilSakKnyttetTilDokumentVersjon(dokumentVersjonId);
    }

    /** Navigerer til arkivdokument i arkivet. Merk at angitt dokumentId må peke til en Arkivdokument. Dersom du har en ArkivdokumentISak må du kalle {@link #gåTilArkivdokumentKnyttetTilDokumentVersjon}*/
    gåTilArkivdokumentKnyttetTilDokument(dokumentId: DokumentId) {
        this.ajsNavigasjon.gåTilArkivdokumentKnyttetTilDokument(dokumentId);
    }

    gåTilArkivdokumentKnyttetTilDokumentVersjon(dokumentVersjonId: DokumentVersjonId) {
        this.ajsNavigasjon.gåTilArkivdokumentKnyttetTilDokumentVersjon(dokumentVersjonId);
    }

    gåTilMøteProtokollFraProtokolldokumentISak(dokumentId: DokumentId) {
        this.ajsNavigasjon.gåTilMøteProtokollFraProtokolldokumentISak(dokumentId);
    }

    gåTilSakEllerArkivKnyttetTilDokumentVersjon(id: DokumentVersjonId) {
        this.ajsNavigasjon.gåTilSakEllerArkivKnyttetTilDokumentVersjon(id);
    }

    gåTilSak(id: AgendaelementId) {
        this.ajsNavigasjon.gåTilSak(id);
    }

    gåTilSakOgDokument(møteId: MøteId, sakId: AgendaelementId, dokumentId: DokumentId) {
        this.ajsNavigasjon.gåTilSakOgDokument(møteId, sakId, dokumentId);
    }

    gåTilBeslutning(id: BeslutningId) {
        //@todo sørge for at vi scroller til aktuell beslutning
        this.ajsNavigasjon.gåTilBeslutning(id);
    }

    gåTilMøteOgSak(møteId: MøteId, sakId: AgendaelementId) {
        this.ajsNavigasjon.gåTilSak2(møteId, sakId);
    }

    gåTilMøteOgSakAsync(møteId: MøteId, sakId: AgendaelementId) {
        this.ajsRootScope.$evalAsync(() =>
          this.ajsNavigasjon.gåTilSak2(møteId, sakId));
    }

    gåTilAvstemning(avstemningId: string, sakId?: string, møteId?: string, erstattLokasjon?: boolean) {
        this.ajsNavigasjon.gåTilAvstemning(avstemningId, sakId, møteId, erstattLokasjon);
    }

    gåTilListeSakerKnyttetTilTema(sak: AgendaelementModellDLM) {
        this.ajsNavigasjon.gåTilListeSakerKnyttetTilTema(sak);
    }

    gåTilListeSakerKnyttetTilSakstype(sak: AgendaelementModellDLM) {
        this.ajsNavigasjon.gåTilListeSakerKnyttetTilSakstype(sak);
    }

    gåTilMøte(id: MøteId) {
        //uten $applyAsync blir ikke navigasjonen fanget opp av MøteKontroller.lyttTilNavigasjon når gåTilMøte kalles fra SakListeOgDetaljerKomponent.vedVisFulltNyeSakerSkjema
        this.ajsRootScope.$applyAsync(() =>
          this.ajsNavigasjon.gåTilMøte(id));
    }

    gåTilMøteAvstemning(id: MøteId) {
        this.ajsNavigasjon.gåTilMøteAvstemning(id);
    }

    gåTilMøteProtokoll(id: MøteId) {
        this.ajsNavigasjon.gåTilMøteProtokoll(id);
    }

    /** Dersom visGenerertForslag er sann vises referat generert fra lydopptak av møtet ekspandert under sakene */
    gåTilRedigerMøteProtokoll(id: MøteId, visGenerertForslag = false) {
        this.ajsNavigasjon.gåTilRedigerMøteProtokoll(id, false, visGenerertForslag)
    }

    gåTilMøteHendelseslogg(id: MøteId) {
        this.ajsNavigasjon.gåTilMøteEndringshendelser(id);
    }

    gåTilGruppeStatistikk(id: GruppeId) {
        this.ajsNavigasjon.gåTilGruppeStatistikk(id);
    }

    gåTilGruppeEndringshendelser(id: GruppeId) {
        this.ajsNavigasjon.gåTilGruppeEndringshendelser(id);
    }

    gåTilGruppeMøtemal(id: GruppeId) {
        this.ajsNavigasjon.gåTilGruppeMøtemal(id);
    }

    gåTilGruppeMøtemalRediger(id: GruppeId) {
        this.ajsNavigasjon.gåTilGruppeMøtemalRediger(id);
    }

    gåTilEntitetRef(entitetRef: EntitetReferanseModell) {
        this.ajsNavigasjon.gåTilEntitetRef(entitetRef);
    }

    gåTilArkivMappe(mappeId: ArkivnodeId) {
        this.ajsNavigasjon.gåTilArkiv(mappeId);
    }

    gåTilOppgaveliste(spesifikasjon: Ng2OppgaveFilterUrlSpesifikasjon) {
        this.ajsNavigasjon.gåTilOppgaveliste(spesifikasjon);
    }

    gåTilOppgave(oppgave: OppgaveId | OppgaveModell) {
        this.ajsNavigasjon.gåTilOppgave(oppgave as any); //ikke nødvendig å konvertere fra ng2 til ajs da ingen dato-felter brukes av mottaker
    }
}

// etterlikner OppgaveFilterUrlSpesifikasjon fra web/moduler/oppgave/komponenter/oppgaverFilter/oppgaverFilter.ts, men uten ajs-typer
type Ng2OppgaveFilterUrlSpesifikasjon = {
    grupper: GruppeId[];
    statuser: OppgavestatusKriterie[];
    ansvarlige: Epost[];
    ansvarligUtvalg: 'alle' | 'mine' | 'valgte';
    sortering?: OppgaveSorteringSpesifikasjon;
    paginering?: OppgavePagineringSpesifikasjon;
}
